import React from 'react';
// import {TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { green } from '@material-ui/core/colors';

import Liste from '../Codification/Liste';
import MyDateField from '../Codification/MyDateField';
import util from '../../utils/util';

export default function ListeReglementVente(){
    const [reglementVentes,setReglementVentes] = React.useState([]);
    const history = useHistory();
   
    const colonnes = [
        { title: 'Date', field: 'date_paiement', type:'date',
            filterComponent: props =>
            <MyDateField 
                name="date_paiement"
                value={props.columnDef.tableData.filterValue||""}
                onChange={e=>{
                    props.columnDef.tableData.filterValue = e.target.value;
                    props.onFilterChanged(props.columnDef.tableData.columnOrder,e.target.value)
                }}
                errors={[]}
                label=" "
            />
        },
        { title: 'Vente', field: 'vente.reference'},
        { title: 'Client', field: 'vente.client.full_name' },
        { title: 'Montant paye', field: 'montant',
            cellStyle:{textAlign:"right"},
            headerStyle:{textAlign:'right'},
            filtering:false,
            render:rowdata=>util.separteurMillier(rowdata.montant) 
        },
    ];
    return (
            <Liste table='reglements-vente' 
                values={reglementVentes} 
                setValues={setReglementVentes}
                colonnes={colonnes}
                editable={{
                    onRowUpdate:null,
                    onRowAdd:null
                }}
                actions={[
                    {
                        icon: 'add_circle',
                        iconProps:{style:{fontSize:50,color:green[500]}},
                        tooltip: 'Nouveau reglement',
                        isFreeAction: true,
                        onClick: (event, rowData) => history.push("/reglements-ventes")
                    },
                    {
                        icon: 'visibility',
                        iconProps:{color:'primary'},
                        tooltip: 'Afficher reglementVente',
                        onClick: (event, rowData) => history.push(`/reglements-ventes/view/${rowData.id}`)
                    },
                    {
                        icon: 'edit',
                        tooltip: 'Modifier reglementVente',
                        onClick: (event, rowData) => history.push(`/reglements-ventes/${rowData.id}`)
                    }
                ]}

            />
    )
};

